import React from 'react';
import { SHADCN, R, FS, softTone } from '../theme';

// ── <DeltaPill> — variation chiffrée avec direction ─────────────────────────
// Pill compacte pour deltas (% vs objectif, vs J-7, etc.). Suit le pattern
// softTone() : fond 12%, bordure 40%, texte plein. La tone dérive de la
// direction par défaut (up=success, down=danger), avec override possible.
//
// Props :
//   direction : 'up' | 'down'             (requis)
//   value     : number                    (requis)
//   suffix    : string                    (optionnel — ex. "vs objectif")
//   size      : 'sm' | 'md'  (def. 'sm')
//   tone      : 'auto'|'success'|'danger'|'neutral' (def. 'auto')
//   unit      : string                    (def. '%')

// Aligné sur l'échelle de StatusPill — 2 tailles partagées.
const SIZES = {
  sm: { fontSize: 11, padding: '2px 8px',  gap: 4 },
  md: { fontSize: FS.xs, padding: '4px 10px', gap: 4 },
};

function resolveTone(tone, direction) {
  if (tone === 'auto') return direction === 'up' ? 'success' : 'danger';
  return tone;
}

function colorsFor(tone) {
  if (tone === 'neutral') return { bg: SHADCN.sidebarAccent, border: SHADCN.border, text: SHADCN.mutedFg };
  if (tone === 'success') return { bg: softTone(SHADCN.success).bg, border: softTone(SHADCN.success).border, text: SHADCN.success };
  if (tone === 'danger')  return { bg: softTone(SHADCN.error).bg,   border: softTone(SHADCN.error).border,   text: SHADCN.error };
  return { bg: SHADCN.sidebarAccent, border: SHADCN.border, text: SHADCN.mutedFg };
}

export default function DeltaPill({
  direction,
  value,
  suffix,
  size = 'sm',
  tone = 'auto',
  unit = '%',
  style,
}) {
  const s = SIZES[size] || SIZES.sm;
  const t = colorsFor(resolveTone(tone, direction));
  const arrow = direction === 'up' ? '▲' : '▼';
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: s.gap,
      padding: s.padding,
      borderRadius: R.pill,
      background: t.bg,
      border: `1px solid ${t.border}`,
      color: t.text,
      fontFamily: SHADCN.font,
      fontSize: s.fontSize,
      fontWeight: 600,
      lineHeight: 1,
      fontVariantNumeric: 'tabular-nums',
      whiteSpace: 'nowrap',
      ...style,
    }}>
      {arrow} {value}{unit}{suffix ? ` ${suffix}` : ''}
    </span>
  );
}
